<template>
  <section
    v-if="sectionTitle && sectionContent"
    class="story"
  >
    <div>
      <h2>{{ sectionTitle }}</h2>
      <article>
        <div
          class="default-text"
          v-html="sectionContent"
        />
      </article>
      <div class="d-flex justify-center">
        <v-btn
          href="/kontakt"
          variant="flat"
          size="x-large"
          color="#d90d83"
        >
          Kontaktovat
        </v-btn>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useMicrositeStore } from '../../stores/useMicrositeStore'

const store = useMicrositeStore()

const sectionTitle = computed(() => store.microsite?.aboutMePageMyStoryTitle)
const sectionContent = computed(() => store.microsite?.aboutMePageMyStoryContent)
</script>
